// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 添加样版 POST /common/template/add_template */
export async function postCommonTemplateAddTemplate(
  body: API.AddTemplateParams,
  options?: { [key: string]: any },
) {
  return request<API.AddTemplateResult>('/common/template/add_template', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 添加样板状态 POST /common/template/add_template_status */
export async function postCommonTemplateAddTemplateStatus(
  body: API.AddTemplateStatusParams,
  options?: { [key: string]: any },
) {
  return request<API.AddTemplateStatusResult>('/common/template/add_template_status', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 添加样版v2 POST /common/template/add_template_v2 */
export async function postCommonTemplateAddTemplateV2(
  body: API.AddTemplateV2Params,
  options?: { [key: string]: any },
) {
  return request<API.AddTemplateV2Result>('/common/template/add_template_v2', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 批量删除样板 POST /common/template/batch_delete_template */
export async function postCommonTemplateBatchDeleteTemplate(
  body: API.BatchDeleteTemplateParams,
  options?: { [key: string]: any },
) {
  return request<API.BatchDeleteTemplateResult>('/common/template/batch_delete_template', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 检查bom单 POST /common/template/check_bom */
export async function postCommonTemplateCheckBom(
  body: API.CheckBomParams,
  options?: { [key: string]: any },
) {
  return request<API.CheckBomResult>('/common/template/check_bom', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除样板 POST /common/template/delete_template */
export async function postCommonTemplateDeleteTemplate(
  body: API.DeleteTemplateParams,
  options?: { [key: string]: any },
) {
  return request<API.DeleteTemplateResult>('/common/template/delete_template', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除样板状态 POST /common/template/delete_template_status */
export async function postCommonTemplateDeleteTemplateStatus(
  body: API.DeleteTemplateStatusParams,
  options?: { [key: string]: any },
) {
  return request<API.DeleteTemplateStatusResult>('/common/template/delete_template_status', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 编辑样板 POST /common/template/edit_template */
export async function postCommonTemplateEditTemplate(
  body: API.EditTemplateParams,
  options?: { [key: string]: any },
) {
  return request<API.EditTemplateResult>('/common/template/edit_template', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 编辑样板款号 POST /common/template/edit_template_no */
export async function postCommonTemplateEditTemplateNo(
  body: API.EditTemplateNoParams,
  options?: { [key: string]: any },
) {
  return request<API.EditTemplateNoResult>('/common/template/edit_template_no', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 编辑样板状态 POST /common/template/edit_template_status */
export async function postCommonTemplateEditTemplateStatus(
  body: API.EditTemplateStatusParams,
  options?: { [key: string]: any },
) {
  return request<API.EditTemplateStatusResult>('/common/template/edit_template_status', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 编辑样版v2 POST /common/template/edit_template_v2 */
export async function postCommonTemplateEditTemplateV2(
  body: API.EditTemplateV2Params,
  options?: { [key: string]: any },
) {
  return request<API.EditTemplateV2Result>('/common/template/edit_template_v2', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取批量删除样板数据 POST /common/template/fetch_delete_template */
export async function postCommonTemplateFetchDeleteTemplate(
  body: API.FetchDeleteTemplateParams,
  options?: { [key: string]: any },
) {
  return request<API.FetchDeleteTemplateResult>('/common/template/fetch_delete_template', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建样版参数 POST /common/template/get_add_template_config */
export async function postCommonTemplateGetAddTemplateConfig(
  body: API.GetAddTemplateConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.GetAddTemplateConfigResult>('/common/template/get_add_template_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 样版通用参数 POST /common/template/get_template_common_config */
export async function postCommonTemplateGetTemplateCommonConfig(
  body: API.GetTemplateCommonConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.GetTemplateCommonConfigResult>('/common/template/get_template_common_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 按款查看成本核算 POST /common/template/get_template_cost_accounting */
export async function postCommonTemplateGetTemplateCostAccounting(
  body: API.GetTemplateCostAccountingParams,
  options?: { [key: string]: any },
) {
  return request<API.GetTemplateCostAccountingResult>(
    '/common/template/get_template_cost_accounting',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 获取样版详情 POST /common/template/get_template_detail */
export async function postCommonTemplateGetTemplateDetail(
  body: API.GetTemplateDetailParams,
  options?: { [key: string]: any },
) {
  return request<API.GetTemplateDetailResult>('/common/template/get_template_detail', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取样版详情v2 POST /common/template/get_template_detail_v2 */
export async function postCommonTemplateGetTemplateDetailV2(
  body: API.GetTemplateDetailV2Params,
  options?: { [key: string]: any },
) {
  return request<API.GetTemplateDetailV2Result>('/common/template/get_template_detail_v2', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取样板图片 POST /common/template/get_template_images */
export async function postCommonTemplateGetTemplateImages(
  body: API.GetTemplateImagesParams,
  options?: { [key: string]: any },
) {
  return request<API.GetTemplateImagesResult>('/common/template/get_template_images', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取样板列表 POST /common/template/get_template_list */
export async function postCommonTemplateGetTemplateList(
  body: API.GetTemplateListParams,
  options?: { [key: string]: any },
) {
  return request<API.GetTemplateListResult>('/common/template/get_template_list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取样版列表头部汇总数据 POST /common/template/get_template_list_header */
export async function postCommonTemplateGetTemplateListHeader(
  body: API.GetTemplateListHeaderParams,
  options?: { [key: string]: any },
) {
  return request<API.GetTemplateListHeaderResult>('/common/template/get_template_list_header', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取样版修改日期 POST /common/template/get_template_log_date */
export async function postCommonTemplateGetTemplateLogDate(
  body: API.GetTemplateLogDateParams,
  options?: { [key: string]: any },
) {
  return request<API.GetTemplateLogDateResult>('/common/template/get_template_log_date', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 样版编辑日志 POST /common/template/get_template_log_list */
export async function postCommonTemplateGetTemplateLogList(
  body: API.GetTemplateLogListParams,
  options?: { [key: string]: any },
) {
  return request<API.GetTemplateLogListResult>('/common/template/get_template_log_list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 样版金额信息 POST /common/template/get_template_price_info */
export async function postCommonTemplateGetTemplatePriceInfo(
  body: API.GetTemplatePriceInfoParams,
  options?: { [key: string]: any },
) {
  return request<API.GetTemplatePriceInfoResult>('/common/template/get_template_price_info', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 样板状态列表 POST /common/template/get_template_status_list */
export async function postCommonTemplateGetTemplateStatusList(
  body: API.GetTemplateStatusListParams,
  options?: { [key: string]: any },
) {
  return request<API.GetTemplateStatusListResult>('/common/template/get_template_status_list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取样版状态日志 POST /common/template/get_template_status_log */
export async function postCommonTemplateGetTemplateStatusLog(
  body: API.GetTemplateStatusLogParams,
  options?: { [key: string]: any },
) {
  return request<API.GetTemplateStatusLogResult>('/common/template/get_template_status_log', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 打印样版 POST /common/template/print_template */
export async function postCommonTemplatePrintTemplate(
  body: API.PrintTemplateParams,
  options?: { [key: string]: any },
) {
  return request<API.PrintTemplateResult>('/common/template/print_template', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 撤销样板状态日志 POST /common/template/revoke_template_status */
export async function postCommonTemplateRevokeTemplateStatus(
  body: API.RevokeTemplateStatusParams,
  options?: { [key: string]: any },
) {
  return request<API.RevokeTemplateStatusResult>('/common/template/revoke_template_status', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 修改样板状态排序 POST /common/template/save_template_status_sort */
export async function postCommonTemplateSaveTemplateStatusSort(
  body: API.SaveTemplateStatusSortParams,
  options?: { [key: string]: any },
) {
  return request<API.SaveTemplateStatusSortResult>('/common/template/save_template_status_sort', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 选择样板列表 POST /common/template/select_template_list */
export async function postCommonTemplateSelectTemplateList(
  body: API.SelectTemplateListParams,
  options?: { [key: string]: any },
) {
  return request<API.SelectTemplateListResult>('/common/template/select_template_list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取批量删除验证码 POST /common/template/send_delete_verify_code */
export async function postCommonTemplateSendDeleteVerifyCode(
  body: API.SendDeleteVerifyCodeParams,
  options?: { [key: string]: any },
) {
  return request<API.SendDeleteVerifyCodeResult>('/common/template/send_delete_verify_code', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 设置样版状态 POST /common/template/set_template_status */
export async function postCommonTemplateSetTemplateStatus(
  body: API.SetTemplateStatusParams,
  options?: { [key: string]: any },
) {
  return request<API.SetTemplateStatusResult>('/common/template/set_template_status', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 设置样版状态岗位 POST /common/template/set_template_status_role */
export async function postCommonTemplateSetTemplateStatusRole(
  body: API.SetTemplateStatusRoleParams,
  options?: { [key: string]: any },
) {
  return request<API.SetTemplateStatusRoleResult>('/common/template/set_template_status_role', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 置顶/取消置顶样版 POST /common/template/set_template_top */
export async function postCommonTemplateSetTemplateTop(
  body: API.SetTemplateTopParams,
  options?: { [key: string]: any },
) {
  return request<API.SetTemplateTopResult>('/common/template/set_template_top', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 预警/取消预警样板 POST /common/template/set_template_warn */
export async function postCommonTemplateSetTemplateWarn(
  body: API.SetTemplateWarnParams,
  options?: { [key: string]: any },
) {
  return request<API.SetTemplateWarnResult>('/common/template/set_template_warn', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 分享样版 POST /common/template/share_template */
export async function postCommonTemplateShareTemplate(
  body: API.ShareTemplateParams,
  options?: { [key: string]: any },
) {
  return request<API.ShareTemplateResult>('/common/template/share_template', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 同步bom到采购单 POST /common/template/sync_purchase_bom */
export async function postCommonTemplateSyncPurchaseBom(
  body: API.SyncPurchaseBomParams,
  options?: { [key: string]: any },
) {
  return request<API.SyncPurchaseBomResult>('/common/template/sync_purchase_bom', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 样版编辑锁 POST /common/template/template_lock */
export async function postCommonTemplateTemplateLock(
  body: API.TemplateLockParams,
  options?: { [key: string]: any },
) {
  return request<API.TemplateLockResult>('/common/template/template_lock', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 锁定/解锁样板 POST /common/template/update_lock_flag */
export async function postCommonTemplateUpdateLockFlag(
  body: API.UpdateLockFlagParams,
  options?: { [key: string]: any },
) {
  return request<API.UpdateLockFlagResult>('/common/template/update_lock_flag', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
